import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
import {ControlPanelService} from '../../services/controlPanel.service';
import {Question} from '../../models/question.model';
import {loadingWrap} from '../../rxjs/rx_loading';

@Component({
  selector: 'app-checkbox-cp-custom',
  templateUrl: './checkbox-cp-custom.component.html'
})
export class CheckboxCpCustomComponent implements OnInit, OnChanges {
    @Input() question: Question;
    @Input() idx: number;
    @Input() data: any;
    @Input() totalApp: number;
    @Input() statistic: boolean;
    @Input() loopCount: number;
    @Input() isViewResult;
    @Input() checkControlPanel: any;
    @Output() getFull = new EventEmitter<any>();
    @Output() getValue = new EventEmitter();
    @Output() getAllResult = new EventEmitter();
    numberApp: number;
    optionCheckbox: number[] = [];
    numberCheckbox = 0;
    score = 0;
    idData: number;
    applicantsFulfill: number;
    options: any;
    questionResults: any;
    constructor(private controlPanelService: ControlPanelService) { }

    ngOnInit() {
      if (this.checkControlPanel != null) {
        this.statistic = true;
      }
        for (const item of this.data) {
            if (item['question_id'] === this.question.id) {
                this.optionCheckbox = item['content'];
                this.numberCheckbox = item['number'];
                this.score = item['score'];
                this.idData = item['id'];
                this.applicantsFulfill = item['applicants_fulfill'];
            }
        }
        this.getApplicantCheckbox();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.loopCount && this.loopCount > 0) {
            this.getApplicantCheckbox();
        }
    }

    getOptionCheckbox(option_id: number) {
        if (this.optionCheckbox.indexOf(option_id) === -1) {
            this.optionCheckbox.push(option_id);
        } else {
            this.optionCheckbox.splice(this.optionCheckbox.indexOf(option_id), 1);
        }
    }

    onGetAllResult() {
        this.getAllResult.emit();
    }

    getApplicantCheckbox() {
        this.controlPanelService.getApplicantCheckbox(this.question.id, this.numberCheckbox, this.optionCheckbox).pipe(loadingWrap()).subscribe(res => {
              this.numberApp = res.results.length;
              const data = {
                id: this.idData,
                question_id: this.question.id,
                type: this.question.type,
                content: this.optionCheckbox,
                number: this.numberCheckbox,
                score: this.score,
                applicants_fulfill: this.numberApp,
                options: this.question.options
              };
              if (typeof this.data !== 'undefined' && this.data.length > 0) {
                for (let item of this.data) {
                  if(item['question_id'] == this.question.id) {
                    data.id = item['id'];
                  }
                }
              }
              if (this.score < 0 ) {
                this.score = 0;
              }
              if (this.score > 99) {
                this.score = 99;
              }
              this.getFull.emit(data);
            }
        );
    }

}
